import React from "react";
import {
    FiChevronDown,
    FiX,
} from "react-icons/fi";

function ReportDetailsModal({
    open,
    onClose,
    reportData,
    loading,
}) {

   // if (!open) return null;

    return (

      //  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div className="bg-white w-full max-w-6xl rounded-xl shadow-2xl overflow-hidden max-h-[95vh] overflow-y-auto">

                {/* HEADER */}

                <div className="flex items-center justify-between px-6 py-4 border-b">

                    <h2 className="text-3xl font-bold w-full text-center">
                        Report Details
                    </h2>

                    {/* <button
                        onClick={onClose}
                        className="text-2xl"
                    >
                        <FiX />
                    </button> */}

                </div>

                {/* LOADING */}

                {loading ? (

                    <div className="p-10 text-center text-xl font-semibold">
                        Loading...
                    </div>

                ) : (

                    <div className="p-6">

                        {/* RESULT TABLE */}

                        <div className="border rounded-lg overflow-hidden">

                            <table className="w-full">

                                <tbody>

                                    <tr className="border-b">

                                        <td className="font-semibold px-4 py-5 bg-gray-50 w-[40%]">
                                            Test Id
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={
                                                    reportData?.testId || ""
                                                }
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                    <tr className="border-b">

                                        <td className="font-semibold px-4 py-5 bg-gray-50">
                                            Test Date
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={
                                                    reportData?.testDate
                                                        ?.split("T")[0] || ""
                                                }
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                    <tr className="border-b">

                                        <td className="font-semibold px-4 py-5 bg-gray-50">
                                            Total Question
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={
                                                    reportData?.totalQuestions || 0
                                                }
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                    <tr className="border-b">

                                        <td className="font-semibold px-4 py-5 bg-gray-50">
                                            Score
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={`${reportData?.score || 0}%`}
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                    <tr className="border-b">

                                        <td className="font-semibold px-4 py-5 bg-gray-50">
                                            Correct Answers
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={
                                                    reportData?.correctAnswers || 0
                                                }
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                    <tr>

                                        <td className="font-semibold px-4 py-5 bg-gray-50">
                                            Incorrect Answers
                                        </td>

                                        <td className="px-4 py-5">

                                            <input
                                                value={
                                                    (reportData?.totalQuestions || 0)
                                                    -
                                                    (reportData?.correctAnswers || 0)
                                                }
                                                readOnly
                                                className="w-full border rounded-lg px-4 py-3"
                                            />

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        {/* QUESTION DETAILS */}

                        <div className="mt-10">

                            <h3 className="text-3xl font-bold mb-5">
                                Question Details
                            </h3>

                            {Array.isArray(
                                reportData?.questionResults
                            ) &&
                                reportData.questionResults.map(
                                    (question, index) => {

                                        const selectedOption =
                                            question?.options?.[
                                            question.markedAnswer - 1
                                            ];

                                        const correctOption =
                                            question?.options?.[
                                            question.correctAnswer - 1
                                            ];

                                        return (

                                            <div
                                                key={index}
                                                className="border rounded-lg overflow-hidden mb-5"
                                            >

                                                {/* QUESTION */}

                                                <div className="px-6 py-5 bg-gray-50">

                                                    <h4
                                                        className="font-semibold text-lg"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                `Q${index + 1}. ${question?.name || ""
                                                                }`,
                                                        }}
                                                    />

                                                </div>

                                                {/* ANSWERS */}

                                                <div className="p-6 space-y-5">

                                                    {/* YOUR ANSWER */}

                                                    <div>

                                                        <p className="text-gray-500 mb-2">
                                                            Your Answer
                                                        </p>

                                                        <div
                                                            className={`border rounded-lg px-4 py-3 font-semibold
                ${question?.isCorrect
                                                                    ? "bg-green-50 text-green-700"
                                                                    : "bg-red-50 text-red-600"
                                                                }`}
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    selectedOption || "",
                                                            }}
                                                        />

                                                    </div>

                                                    {/* CORRECT ANSWER */}

                                                    <div>

                                                        <p className="text-gray-500 mb-2">
                                                            Correct Answer
                                                        </p>

                                                        <div
                                                            className="border rounded-lg px-4 py-3 bg-green-50 text-green-700 font-semibold"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    correctOption || "",
                                                            }}
                                                        />

                                                    </div>

                                                </div>

                                            </div>

                                        );

                                    }
                                )}
                        </div>

                        {/* FOOTER */}

                        <div className="mt-8">

                            <button
                                onClick={onClose}
                                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg font-semibold"
                            >
                                ← Back to MCQ Report
                            </button>

                        </div>

                    </div>

                )}

            </div>

        </div>

    );

}

export default ReportDetailsModal;